// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"169":"679ae062","453":"ccf708ac","672":"b0ba9678","778":"8bbc322f","789":"6cdee037","897":"3f9c24d7"}[chunkId] + ".chunk.js";
};